import React from 'react';
import { Link } from 'react-router-dom';
import invisionLogo from '../images/invisionLogo.png';

const Header = () => {
  return (
    <header className="text-white bg-transparent pb-16 w-4/5 mx-auto">
      <div className="flex items-center justify-start md:px-6 md:mt-6">
        <Link to="/" className="block">
          <img
            src={invisionLogo}
            alt="QRT Logo"
            className="h-12 mt-6 md:mt-0 transition-all duration-300 mb-2 max-w-full"
          />
        </Link>
      </div>
    </header>
  );
};

export default Header;